import { render, staticRenderFns } from "./Notificacao.vue?vue&type=template&id=1b70a19d&scoped=true&"
import script from "./Notificacao.vue?vue&type=script&lang=js&"
export * from "./Notificacao.vue?vue&type=script&lang=js&"
import style0 from "./Notificacao.vue?vue&type=style&index=0&id=1b70a19d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b70a19d",
  null
  
)

export default component.exports